import React from 'react';
import PropTypes from 'prop-types';

import Box from '@quintoandar/cozy-core/Box';
import Typography from '@quintoandar/cozy-core/Typography';

import SpacedInput from 'components/SpacedInput';

import {
  PHOTO_SECTION_SLUG,
  NOTES_ITEM_SLUG,
  NOTES_MAX_LENGTH,
} from './constants';

export const onChange = ({ onChangeNotes, previousValue }) => event => {
  if (event.target.value.length > NOTES_MAX_LENGTH) {
    return;
  }
  onChangeNotes({
    section: PHOTO_SECTION_SLUG,
    itemSlug: NOTES_ITEM_SLUG,
    value: event.target.value,
    previousValue,
  });
};

export const OverviewNotes = ({ onChangeNotes, onBlurNotes, section }) => (
  <>
    <Box mt={2}>
      <Typography level="bodyStrong">{section.label}</Typography>
    </Box>
    <SpacedInput
      id={'notes'}
      value={section.items.photoSessionNotes.value}
      onChange={onChange({
        onChangeNotes,
        previousValue: section.items.photoSessionNotes.value,
      })}
      onBlur={onBlurNotes}
      maxLength={NOTES_MAX_LENGTH}
      withCounter
      multiline
      intlKey={section.items.photoSessionNotes.key}
    />
  </>
);

OverviewNotes.propTypes = {
  onChangeNotes: PropTypes.func.isRequired,
  onBlurNotes: PropTypes.func,
  section: PropTypes.shape({
    label: PropTypes.string,
    items: PropTypes.shape({
      photoSessionNotes: PropTypes.shape({
        value: PropTypes.string,
        key: PropTypes.string,
      }),
    }),
  }),
};

export default OverviewNotes;
